import { useState } from "react";
import { useLanguage } from '../config/language/LanguageContext';

export default function FAQSection() {
  const { locale } = useLanguage();
  const [openIndex, setOpenIndex] = useState(null);
  const { heading, subheading, items: faqs } = locale.FAQ;

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq-section" className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl font-semibold text-gray-800 text-center">
          {heading.split(". ").map((line, i) => (
            <span key={i}>
              {line}.
              <br />
            </span>
          ))}
        </h2>
        <p className="text-gray-500 text-center mt-4">
          {subheading}
        </p>

        <div className="mt-12 space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border-b border-gray-200 cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              <div className="flex justify-between items-center py-4">
                <h3 className="text-lg font-medium text-gray-800">
                  {faq.question}
                </h3>
                <button className="text-orange-500">
                  {openIndex === index ? "−" : "+"}
                </button>
              </div>

              {openIndex === index && (
                <div className="pb-4 text-gray-600">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
